interface CategoryColorSwatchProps {
  colorHex: string;
  size?: 'sm' | 'md';
  isPtoEquivalent?: boolean;
}

export function CategoryColorSwatch({ colorHex, size = 'sm', isPtoEquivalent = false }: CategoryColorSwatchProps) {
  const dim = size === 'sm' ? 'w-3.5 h-3.5' : 'w-5 h-5';
  const style: React.CSSProperties = { backgroundColor: colorHex };
  if (isPtoEquivalent) {
    style.backgroundImage =
      'repeating-linear-gradient(-45deg, transparent, transparent 3px, rgba(255,255,255,0.4) 3px, rgba(255,255,255,0.4) 4px)';
  }
  return <span className={`${dim} rounded inline-block shrink-0`} style={style} aria-hidden="true" />;
}
